import useSWR from 'swr';
import { BrowseCategoryFetchers } from '@members/data-fetch';
import { useLocale } from '@members/localization';

export const useBrowseCategoriesData = () => {
  const locale = useLocale();
  return useSWR(
    ...BrowseCategoryFetchers.BrowseCategories({
      pelotonPlatform: 'web',
      acceptLanguage: locale,
    }),
  );
};
